import { UserCheck, ListChecks } from "lucide-react";
import { Field, Chip } from "./FormPrimitives";

const BULLET = "\u2022";

/** Toggle an example question as a bullet line inside the free-text question. */
export function toggleQuestionLine(current, question) {
  const text = current || "";
  if (text.includes(question)) {
    return text
      .split("\n")
      .filter((line) => line.replace(new RegExp(`^${BULLET}\\s*`), "").trim() !== question)
      .join("\n")
      .trim();
  }
  return text ? `${text}\n${BULLET} ${question}` : question;
}

export const AgeRangeField = ({ options, value, error, onChange }) => (
  <div>
    <label className="block text-sm font-medium text-[#122131] mb-2">
      Age Range <span className="text-[#c0392b]">*</span>
    </label>
    <div className="flex flex-wrap gap-2">
      {options.map((a) => (
        <Chip key={a} testId={`age-range-${a}`} selected={value === a} onClick={() => onChange(a === value ? "" : a)}>
          {a}
        </Chip>
      ))}
    </div>
    {error && (
      <p className="mt-2 text-sm text-[#c0392b]" data-testid="age-range-error">{error}</p>
    )}
  </div>
);

const PREFILL_NOTE_STYLE = { background: "rgba(18,111,106,0.08)", color: "#126F6A" };

export const QuestionField = ({ prompts, value, prefilled, onChange }) => (
  <Field label="Biggest CPF Question" optional>
    <div className="flex flex-wrap gap-2 mb-2.5">
      {prompts.map((q) => (
        <Chip
          key={q}
          size="sm"
          testId={`question-prompt-${q}`}
          selected={(value || "").includes(q)}
          onClick={() => onChange(toggleQuestionLine(value, q))}
        >
          {q}
        </Chip>
      ))}
    </div>
    {prefilled && (
      <p
        data-testid="question-prefill-note"
        className="mb-2 inline-flex items-start gap-2 rounded-lg px-3 py-2 text-xs leading-relaxed"
        style={PREFILL_NOTE_STYLE}
      >
        <ListChecks size={14} className="mt-0.5 shrink-0" />
        <span>Added from your self-check above. Edit or add anything else you would like covered.</span>
      </p>
    )}
    <textarea
      data-testid="input-question"
      rows={prefilled ? 5 : 3}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Tap an example above or type your own question"
      className="reg-input resize-none"
    />
  </Field>
);

const DETECTED_STYLE = { background: "rgba(31,145,136,0.10)", color: "#126F6A", border: "1px solid rgba(31,145,136,0.25)" };

export const InvitedByField = ({ referralCode, adviserName, value, onChange }) => (
  <div>
    <label className="block text-sm font-medium text-[#122131] mb-2">
      Invited By <span className="text-[#647384] font-normal">(optional)</span>
    </label>
    {referralCode ? (
      <div
        data-testid="invited-by-detected"
        className="inline-flex items-center gap-2 rounded-xl px-4 h-11 text-sm font-medium"
        style={DETECTED_STYLE}
      >
        <UserCheck size={16} /> Invited by {adviserName || referralCode}
      </div>
    ) : (
      <input
        data-testid="referral-code-input"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Adviser name or referral code"
        className="reg-input"
      />
    )}
  </div>
);
